import { css } from '@emotion/react'

export default css`
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@600;700&display=swap');
`
